import React, { Fragment } from 'react';
import Select from "react-select";
import { SelectErrorTheme, SelectSuccessTheme } from './ThemeSelectBox';
import { IoAddCircle, IoSearchSharp } from "react-icons/io5";
import { FaEye } from "react-icons/fa6";

const SelectionBox = ({
  name, isLoading, required, clear, menuIsOpen, menuPlacement, disabled, add_btn, onClick, focus, search_btn, view_btn, view_click,
  label, placeholder, value, optionSelect, handleBlur, touched, errors, options, isMulti = false, openMenuOnFocus=true
}) => {

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#fff',
      borderColor: "silver",
      border: state.isFocused ? "2px solid green" : errors || (errors && touched) ? "1.5px solid red" : "1px solid silver",
      height: "30px",
      fontFamily: 'sans-serif',
      minHeight: "30px",
      boxShadow: state.isFocused ? null : null,
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: "30px",
      bottom: "3.5px",
    }),
    input: (provided, state) => ({
      ...provided,
      fontSize: "14px",
      fontWeight: 400,
      fontFamily: 'sans-serif'
    }),
    indicatorSeparator: state => ({
      display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: '30px',
    }),
    placeholder: (provided, state) => ({
      ...provided,
      marginTop: "0px",
      fontSize: '12px', // Adjust the font size as needed
      fontFamily: 'sans-serif',
      color: "gray",
      opacity: ".5",
      userSelect: "none",
      overflow: "hidden"
    }),
    option: (provided, state) => ({
      ...provided,
      zIndex: "99999",
      position: "sticky",
      paddingLeft: '10px', 
      paddingRight: '6px', // Adjust the padding as needed
      paddingTop: '6px', // Adjust the padding as needed
      paddingBottom: '6px', // Adjust the padding as needed
      fontSize: '12px', // Adjust the font size as needed
      fontFamily: 'sans-serif',
    }),
  };
  return (
    <Fragment>
      <div>
      {label ? <div className='flex justify-between w-full'>
        <div className='flex flex-row w-full'>
          <label className="block text-[12px] mb-1 font-medium text-gray700 dark:text-gray-200 font-sans" htmlFor={name}>{label}</label>
          {!add_btn && !search_btn && required ? <span className='text-red-500 pl-2'>*</span> : ""}
          {add_btn ? <IoAddCircle onClick={onClick} fontSize={20} className='text-customPrimary pl-1 cursor-pointer' /> : ""}
          {search_btn ? <IoSearchSharp onClick={onClick} fontSize={20} className='text-customPrimary pl-1 cursor-pointer' /> : ""}
        </div>
        <div>
          {view_btn ? <FaEye onClick={view_click} fontSize={20} className='text-red-500 pl-1 cursor-pointer' /> : ""}
        </div>
      </div> : ""}
      <Select
        options={options}
        isMulti={isMulti}
        menuIsOpen={menuIsOpen}
        openMenuOnFocus={openMenuOnFocus}
        isClearable={clear}
        onChange={(selectedOption) => optionSelect(name, selectedOption)}
        theme={errors && touched ? SelectErrorTheme : SelectSuccessTheme}
        value={options?.find(opt => opt?.value?.toString() === value?.toString()) || null}
        defaultValue={options?.find(opt => opt.value?.toString() === value?.toString()) || null}
        menuPlacement={menuPlacement || 'bottom'}
        isSearchable
        isDisabled={disabled || false}
        isLoading={isLoading || false}
        className="text-[13px] !w-full"
        onBlur={handleBlur}
        styles={{ ...customStyles, menuPortal: base => ({ ...base, zIndex: 9999 }) }}
        placeholder={placeholder || ""}
        required={required}
        menuPortalTarget={document.body} 
        aria-label={label}
      />
      {errors && <div className='text-red-500 text-[12px] font-public-sans mt-1'>{errors}</div>}
      </div>
    </Fragment>
  );
};

export default SelectionBox;
